import React, { useEffect, useRef, useState } from 'react';
import { Sun, Moon } from 'lucide-react';
import './os3.css';

/* KITXENS Design System v3 — theme engine + core primitives */

export function useOsTheme() {
  const [theme, setTheme] = useState(() => localStorage.getItem('kx_os_theme') || 'light');
  useEffect(() => {
    document.documentElement.setAttribute('data-os-theme', theme);
    localStorage.setItem('kx_os_theme', theme);
  }, [theme]);
  return [theme, setTheme];
}

export const ThemeToggle = ({ theme, setTheme, isEs }) => (
  <button
    onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')}
    className="w-8 h-8 rounded-full border flex items-center justify-center transition-colors"
    style={{ borderColor: 'var(--os-border)', background: 'var(--os-surface)', color: 'var(--os-ink-soft)' }}
    title={isEs ? (theme === 'dark' ? 'Tema claro' : 'Tema oscuro') : (theme === 'dark' ? 'Light theme' : 'Dark theme')}
    aria-label="Toggle theme" data-testid="os3-theme-toggle">
    {theme === 'dark' ? <Sun className="w-4 h-4 text-[#F77F11]" /> : <Moon className="w-4 h-4" />}
  </button>
);

export function AnimatedNumber({ value, format = (v) => Math.round(v).toLocaleString(), duration = 900 }) {
  const [display, setDisplay] = useState(0);
  const ref = useRef();
  useEffect(() => {
    const from = ref.current ?? 0;
    const to = Number(value) || 0;
    ref.current = to;
    const t0 = performance.now();
    let raf;
    const tick = (t) => {
      const p = Math.min(1, (t - t0) / duration);
      const eased = 1 - Math.pow(1 - p, 3);
      setDisplay(from + (to - from) * eased);
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [value, duration]);
  return <>{format(display)}</>;
}

export const OsCard = ({ children, className = '', glow = false, ...rest }) => (
  <div
    className={`rounded-2xl border os3-lift ${className}`}
    style={{
      background: 'var(--os-surface)', borderColor: 'var(--os-border)',
      ...(glow ? { boxShadow: '0 0 24px 0 var(--os-glow)' } : {}),
    }}
    {...rest}>
    {children}
  </div>
);

export const Skeleton = ({ className = '' }) => <div className={`os3-skeleton ${className}`} aria-hidden="true" />;
